import { useEffect } from 'react';
import './OurProcess.css';
import SEOHead from '../../components/SEOHead';
import { SEO_CONFIG, getCanonicalUrl } from '../../config/seo';

function OurProcess() {

  useEffect(() => {
    document.title = 'Our Process | Phoenix Unity Designs';
  }, []);

  return (
    <>
      <SEOHead
        title={SEO_CONFIG.ourProcess.title}
        description={SEO_CONFIG.ourProcess.description}
        keywords={SEO_CONFIG.ourProcess.keywords}
        canonical={getCanonicalUrl(SEO_CONFIG.ourProcess.path)}
        ogUrl={getCanonicalUrl(SEO_CONFIG.ourProcess.path)}
      />
      <main id="main-content" tabIndex="-1" className='OurProcess page-container'>
      <div className='container mb-5'>
        <div className='row'>
          <div className='col'>
            <h1>Our Process</h1>
            <h2>Initial Construction</h2>
            <p>We make sure you get what you are looking for. Even if you don't know what exactly you want, we will help you figure that out.</p>

            <ol>
              <li><p>Initial Meeting: This is where we get to know you, your current situation, your goals. We will propose some recommendations to help you achieve your desired outcome. Then we will settle on a price that works for your goals, timeline, and budget.</p></li>
              <li><p>Development Phase: You will have regular updates so you can see the velocity of the project and provide feedback early and often to help ensure you receive your dream website.</p></li>
              <li><p>Completion Meeting: We'll ensure you are completely satisfied with your website. Then we will discuss the maintenance schedule going forward so that you can have us update your content, patch security vulnerabilities, manage hosting & DNS payments so that you don't have to worry about any of that.</p></li>
            </ol>

            <h2 className='mt-5'>Continued Support &amp; Maintenance</h2>
            <p>After your website is up & running and showing your brand to the world, we will maintain it for you. This includes:</p>
            <ul>
              <li>Content updates</li>
              <li>Patching security vulnerabilities</li>
              <li>Ensuring the website stays up and running</li>
            </ul>
          </div>
        </div>
      </div>
    </main>
    </>
  );
}

export default OurProcess;
